export default __webpack_public_path__ + "static/fdfm-6fdd79b6d9942fe0118d2363faca14f1.png";